import { LitElement, css, html } from '~/lib/bn-lit-element';
import { sharedStyles } from '../styles/shared-styles';
import { bannerStyles } from '../styles/banner-styles';

class PageNotFound extends LitElement {
  static get styles() {
    return [sharedStyles, bannerStyles, css`
      .header {
        margin-bottom: 0.2em;
      }
    `];
  }

  render() {
    return html`
      <div>
        <div class="banner banner--critical">
          <div class="header">Page not found.</div>
          <div><code>Sorry, this page does not exist: ${window.location.toString()}</code></div>
        </div>
      </div>
    `;
  }
}

window.customElements.define('page-not-found', PageNotFound);
